import { DrawerProps } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Resizable } from '../resizable';
import { Drawer } from './drawer';

type Props = {
  children: React.ReactNode;
  offset: number;
  maxWidth?: number;
  minWidth?: number;
  disabled?: boolean;
};

const StyledDrawer = styled(Drawer)<{ offset: number }>`
  position: absolute;
  left: ${(props) => `${props.offset}px`};

  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const ResizableDrawer = (props: Props & DrawerProps) => {
  const {
    children,
    offset,
    onClose,
    visible,
    maxWidth,
    minWidth,
    disabled = false,
  } = props;
  const [width, setWidth] = useState(256);

  return (
    <StyledDrawer
      closeIcon={<></>}
      offset={offset}
      width={width}
      visible={visible}
      onClose={onClose}
      placement="left"
      mask
    >
      <Resizable
        initialWidth={width}
        onChange={(w) => setWidth(w)}
        offset={offset}
        minWidth={minWidth}
        maxWidth={maxWidth}
        disabled={disabled}
      >
        {children}
      </Resizable>
    </StyledDrawer>
  );
};
